export default __webpack_public_path__ + "static/media/TL07.afd5d659.mp3";